import { useCallback, useState } from "react";
import { DisplayedMessages } from "../../../../../common/ChatComponents/DisplayedMessages";
import { useAppModals } from "../../../../../app/state/modalSlice/hook/use-app-modals";
import { FileTransferModal } from "../../../../Modals/FileTransferModal";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import {
  selectEditorMessages,
  selectIsLegacySpaObject,
  selectIsMessageLoading,
  selectSpaValue,
} from "../../../redux/selectors";
import { useFileTransferModal } from "../../../../Modals/FileTransferModal/hook/use-file-transfer-modal";
import { TFileTransferInfo } from "../../../../Modals/FileTransferModal/types";
import { selectUserArtifactGroup } from "../../../../Auth/redux/selectors";
import styles from "./styles.module.css";
import { AppButton } from "../../../../../shared/components/AppButton";
import { FileIcon } from "../../../../../shared/icons/FileIcon";
import { generateBlobUrlWithHtml } from "../../../helpers/generateBlobUrlWithHtml";

interface Props {
  className?: string;
}

export const AgentChat = ({ className }: Props) => {
  const isLegacyObject = useAppSelector(selectIsLegacySpaObject);
  const spaValue = useAppSelector(selectSpaValue);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const [info, setInfo] = useState<TFileTransferInfo | null>(null);
  const messages = useAppSelector(selectEditorMessages);
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const artifacts = useAppSelector(selectUserArtifactGroup);
  const { handleClick } = useFileTransferModal(info);

  const handleFileClick = useCallback(
    (url: string, filename: string) => {
      const codeUrl = isLegacyObject
        ? generateBlobUrlWithHtml(spaValue?.spa_object?.html_content ?? "")
        : url;
      setInfo({
        url: codeUrl,
        name: "index.html",
      });
      if (artifacts) {
        handleOpenModal("file_transfer_modal", null);
      } else {
        handleClick("download");
      }
    },
    [info, artifacts, spaValue?.spa_object?.html_content],
  );

  const handleCleanModal = () => {
    setInfo(null);
    handleCloseModal("file_transfer_modal");
  };

  return (
    <>
      {(!messages || messages.length === 0) && (
        <AppButton
          buttonType={"outlined"}
          onClick={() => handleFileClick(info?.url ?? "", info?.name ?? "")}
          icon={<FileIcon />}
          className={styles["download-code-btn"]}
        >
          Скачать код сайта
        </AppButton>
      )}
      <DisplayedMessages
        messages={messages}
        isLoading={isMessageLoading}
        onFileClick={handleFileClick}
      />
      <FileTransferModal
        closeModal={handleCleanModal}
        handleActions={handleClick}
      />
    </>
  );
};
